<template>
  <!-- Add Warehouse -->
  <div class="modal fade" id="add-units">
    <div class="modal-dialog modal-dialog-centered warehouse-modal">
      <div class="modal-content shadow-lg border-0 rounded-4">
        <div class="modal-body p-4 p-md-5">
          <div class="d-flex align-items-center justify-content-between mb-4">
            <div>
              <p class="warehouse-eyebrow mb-1">Inventaire</p>
              <h4 class="warehouse-title mb-0">Ajouter un Entrepôt</h4>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <form @submit.prevent="onSubmit" class="warehouse-form">
            <div class="row g-4">
              <div class="col-lg-6 col-12">
                <label class="warehouse-label">Nom de l'entrepôt</label>
                <input
                  v-model="form.name"
                  type="text"
                  class="form-control warehouse-input"
                  placeholder="Ex : Entrepôt Casablanca"
                  required
                />
                <small class="text-muted">Nom visible pour votre équipe.</small>
              </div>
              <div class="col-lg-6 col-12">
                <label class="warehouse-label">Adresse</label>
                <input
                  v-model="form.address"
                  type="text"
                  class="form-control warehouse-input"
                  placeholder="Rue, Ville"
                  required
                />
                <small class="text-muted">Adresse de référence ou de livraison.</small>
              </div>
            </div>

            <div class="warehouse-footer mt-4">
              <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal">
                Annuler
              </button>
              <button type="submit" class="btn btn-primary px-4">
                Créer l'entrepôt
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Warehouse -->

  <!-- Edit Warehouse -->
  <div class="modal fade" id="edit-units">
    <div class="modal-dialog modal-dialog-centered warehouse-modal">
      <div class="modal-content shadow-lg border-0 rounded-4">
        <div class="modal-body p-4 p-md-5">
          <div class="d-flex align-items-center justify-content-between mb-4">
            <div>
              <p class="warehouse-eyebrow mb-1">Inventaire</p>
              <h4 class="warehouse-title mb-0">Modifier l'entrepôt</h4>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <form @submit.prevent="onSubmit1" class="warehouse-form">
            <div class="row g-4">
              <div class="col-lg-6 col-12">
                <label class="warehouse-label">Nom de l'entrepôt</label>
                <input
                  v-model="form1.name"
                  type="text"
                  class="form-control warehouse-input"
                  placeholder="Entrepôt principal"
                  required
                />
                <small class="text-muted">Utilisez un nom clair et descriptif.</small>
              </div>
              <div class="col-lg-6 col-12">
                <label class="warehouse-label">Adresse</label>
                <input
                  v-model="form1.address"
                  type="text"
                  class="form-control warehouse-input"
                  placeholder="Rue, Ville"
                  required
                />
                <small class="text-muted">Précisez l'emplacement physique.</small>
              </div>
            </div>

            <div class="warehouse-footer mt-4">
              <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal">
                Annuler
              </button>
              <button type="submit" class="btn btn-primary px-4">
                Enregistrer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { createWarehouse, updateWarehouse } from "@/services/productsService";
import { decodeToken } from "@/services/jwtService";
import { toast } from "vue3-toastify";

import { Modal } from "bootstrap";
export default {
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        name: "",
        address: "",
      },
      form1: {
        name: "",
        address: "",
      },
    };
  },
  methods: {
    async onSubmit() {
      try {
        let user = decodeToken(localStorage.getItem("access_token"));

        const response = await createWarehouse({
          nom: this.form.name,
          adresse: this.form.address,
          societe_id: user.societe_id,
        });
        this.$emit("warehouse-added", response);

        const modalElement = document.getElementById("add-units");
        const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
        modal.hide();
        this.form.name = "";
        this.form.address = "";
        toast.success("Entrepôt créé avec succès !");
      } catch (error) {
        console.error(error);
        toast.error(error.response?.data?.message || "Erreur lors de la création");
      }
    },
    async onSubmit1() {
      try {
        let user = decodeToken(localStorage.getItem("access_token"));
        const response = await updateWarehouse(this.data.id, {
          nom: this.form1.name,
          adresse: this.form1.address,
          societe_id: user.societe_id,
        });
        this.$emit("warehouse-updated", response);

        const modalElement = document.getElementById("edit-units");
        const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
        modal.hide();
        toast.success("Entrepôt mis à jour");
      } catch (error) {
        console.error(error);
        toast.error(error.response?.data?.message || "Erreur lors de la mise à jour");
      }
    },
  },
  mounted() {},
  watch: {
    data: {
      immediate: true,
      handler(newData) {
        this.form1.name = newData?.Warehouse || "";
        this.form1.address = newData?.address || "";
      },
    },
  },
};
</script>

<style scoped>
.warehouse-modal {
  max-width: 720px;
}

.warehouse-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #0f172a;
}

.warehouse-eyebrow {
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #94a3b8;
}

.warehouse-label {
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
  display: block;
}

.warehouse-input {
  border-radius: 10px;
  border: 1px solid rgba(148, 163, 184, 0.6);
  padding: 12px 14px;
  font-size: 0.95rem;
}

.warehouse-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.warehouse-footer .btn {
  border-radius: 10px;
  font-weight: 600;
}

.btn-close {
  background-color: rgba(226, 232, 240, 0.8);
  border-radius: 14px;
  padding: 10px;
}

@media (max-width: 575px) {
  .warehouse-modal {
    margin: 0 10px;
  }

  .warehouse-title {
    font-size: 1.25rem;
  }
}
</style>
